angular.module('unergie.main')
.filter('float', () =>
    (val) => parseFloat(val),
)
